import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWorkflows = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.93411 18.1341H14.7341C15.3574 18.1341 15.8674 17.6241 15.8674 17.0008V7.93411C15.8674 7.31078 15.3574 6.80078 14.7341 6.80078H7.93411C7.31078 6.80078 6.80078 7.31078 6.80078 7.93411V17.0008C6.80078 17.6241 7.31078 18.1341 7.93411 18.1341ZM7.93411 27.2008H14.7341C15.3574 27.2008 15.8674 26.6908 15.8674 26.0674V21.5341C15.8674 20.9108 15.3574 20.4008 14.7341 20.4008H7.93411C7.31078 20.4008 6.80078 20.9108 6.80078 21.5341V26.0674C6.80078 26.6908 7.31078 27.2008 7.93411 27.2008ZM19.2674 27.2008H26.0674C26.6908 27.2008 27.2008 26.6908 27.2008 26.0674V17.0008C27.2008 16.3774 26.6908 15.8674 26.0674 15.8674H19.2674C18.6441 15.8674 18.1341 16.3774 18.1341 17.0008V26.0674C18.1341 26.6908 18.6441 27.2008 19.2674 27.2008ZM18.1341 7.93411V12.4674C18.1341 13.0908 18.6441 13.6008 19.2674 13.6008H26.0674C26.6908 13.6008 27.2008 13.0908 27.2008 12.4674V7.93411C27.2008 7.31078 26.6908 6.80078 26.0674 6.80078H19.2674C18.6441 6.80078 18.1341 7.31078 18.1341 7.93411Z",
		fill: "white"
	})
});
export default SvgWorkflows;
